// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-dealer-info {
  /* Colors */
  --perxis-auto-dealer-info-background-color-inner: var(
    --perxis-auto-dealer-info-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Scrollbar */
  --perxis-auto-dealer-info-scrollbar-width-inner: var(--perxis-auto-dealer-info-scrollbar-width, 8px);
  --perxis-auto-dealer-info-scrollbar-track-background-color-inner: var(
    --perxis-auto-dealer-info-scrollbar-track-background-color,
    var(--perxis-auto-root-seventh-color-inner)
  );
  --perxis-auto-dealer-info-scrollbar-thumb-background-color-inner: var(
    --perxis-auto-dealer-info-scrollbar-thumb-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-dealer-info-scrollbar-thumb-border-radius-inner: var(
    --perxis-auto-dealer-info-scrollbar-thumb-border-radius,
    5px
  );
  /* End Scrollbar */
  /* Padding */
  --perxis-auto-dealer-info-padding-inner: var(
    --perxis-auto-dealer-info-padding,
    var(--perxis-auto-gap-vertical-sky-inner) 18px
  );
  /* End Padding */
  padding: var(--perxis-auto-dealer-info-padding-inner);
  background-color: var(--perxis-auto-dealer-info-background-color-inner);
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: var(--perxis-auto-dealer-info-scrollbar-thumb-background-color-inner);
  height: 100%;
}
.perxis-auto-1_18_1-dealer-info::-webkit-scrollbar {
  width: var(--perxis-auto-dealer-info-scrollbar-width-inner);
}
.perxis-auto-1_18_1-dealer-info::-webkit-scrollbar-track {
  background: var(--perxis-auto-dealer-info-scrollbar-track-background-color-inner);
}
.perxis-auto-1_18_1-dealer-info::-webkit-scrollbar-thumb {
  background-color: var(--perxis-auto-dealer-info-scrollbar-thumb-background-color-inner);
  border-radius: var(--perxis-auto-dealer-info-scrollbar-thumb-border-radius-inner);
}

.perxis-auto-1_18_1-dealer-info-header {
  /* Typography */
  --perxis-auto-dealer-info-header-icon-size-inner: var(--perxis-auto-dealer-info-header-icon-size, 21px);
  --perxis-auto-dealer-info-header-label-font-family-inner: var(
    --perxis-auto-dealer-info-header-label-font-family,
    var(--perxis-auto-root-typography-small-font-family)
  );
  --perxis-auto-dealer-info-header-label-font-size-xxl-inner: var(
    --perxis-auto-dealer-info-header-label-font-size-xxl,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-header-label-font-size-xl-inner: var(
    --perxis-auto-dealer-info-header-label-font-size-xl,
    var(--perxis-auto-dealer-info-header-label-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-header-label-font-size-lg-inner: var(
    --perxis-auto-dealer-info-header-label-font-size-lg,
    var(--perxis-auto-dealer-info-header-label-font-size-xl-inner)
  );
  --perxis-auto-dealer-info-header-label-font-size-md-inner: var(
    --perxis-auto-dealer-info-header-label-font-size-md,
    var(--perxis-auto-dealer-info-header-label-font-size-lg-inner)
  );
  --perxis-auto-dealer-info-header-label-font-size-sm-inner: var(
    --perxis-auto-dealer-info-header-label-font-size-sm,
    var(--perxis-auto-dealer-info-header-label-font-size-md-inner)
  );
  --perxis-auto-dealer-info-header-label-font-size-xs-inner: var(
    --perxis-auto-dealer-info-header-label-font-size-xs,
    var(--perxis-auto-dealer-info-header-label-font-size-sm-inner)
  );
  --perxis-auto-dealer-info-header-label-font-size-xxs-inner: var(
    --perxis-auto-dealer-info-header-label-font-size-xxs,
    var(--perxis-auto-dealer-info-header-label-font-size-xs-inner)
  );
  --perxis-auto-dealer-info-header-label-font-weight-inner: var(
    --perxis-auto-dealer-info-header-label-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-header-label-letter-spacing-inner: var(
    --perxis-auto-dealer-info-header-label-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-header-label-line-height-xxl-inner: var(
    --perxis-auto-dealer-info-header-label-line-height-xxl,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-dealer-info-header-label-line-height-xl-inner: var(
    --perxis-auto-dealer-info-header-label-line-height-xl,
    var(--perxis-auto-root-typography-small-line-height-xl-inner)
  );
  --perxis-auto-dealer-info-header-label-line-height-lg-inner: var(
    --perxis-auto-dealer-info-header-label-line-height-lg,
    var(--perxis-auto-root-typography-small-line-height-lg-inner)
  );
  --perxis-auto-dealer-info-header-label-line-height-md-inner: var(
    --perxis-auto-dealer-info-header-label-line-height-md,
    var(--perxis-auto-root-typography-small-line-height-md-inner)
  );
  --perxis-auto-dealer-info-header-label-line-height-sm-inner: var(
    --perxis-auto-dealer-info-header-label-line-height-sm,
    var(--perxis-auto-root-typography-small-line-height-sm-inner)
  );
  --perxis-auto-dealer-info-header-label-line-height-xs-inner: var(
    --perxis-auto-dealer-info-header-label-line-height-xs,
    var(--perxis-auto-root-typography-small-line-height-xs-inner)
  );
  --perxis-auto-dealer-info-header-label-line-height-xxs-inner: var(
    --perxis-auto-dealer-info-header-label-line-height-xxs,
    var(--perxis-auto-root-typography-small-line-height-xxs-inner)
  );
  --perxis-auto-dealer-info-header-label-text-transform-inner: var(
    --perxis-auto-dealer-info-header-label-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  /* End Typography*/
  /* Colors */
  --perxis-auto-dealer-info-header-icon-color-inner: var(
    --perxis-auto-dealer-info-header-icon-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  --perxis-auto-dealer-info-header-hover-icon-color-inner: var(
    --perxis-auto-dealer-info-header-hover-icon-color,
    var(--perxis-auto-root-third-color-inner)
  );
  /* End Colors */
  --perxis-auto-button-text-icon-color: var(--perxis-auto-dealer-info-header-icon-color-inner);
  --perxis-auto-button-text-icon-hover-color: var(--perxis-auto-dealer-info-header-hover-icon-color-inner);
  display: flex;
  align-items: center;
}
.perxis-auto-1_18_1-dealer-info-header__icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-dealer-info-header-icon-size-inner);
}
.perxis-auto-1_18_1-dealer-info-header__label {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-header-label-font-family-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-header-label-font-size-xxl-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-header-label-font-size-xl-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-header-label-font-size-lg-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-header-label-font-size-md-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-header-label-font-size-sm-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-header-label-font-size-xs-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-header-label-font-size-xxs-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-header-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-header-label-letter-spacing-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-header-label-line-height-xxl-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-header-label-line-height-xl-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-header-label-line-height-lg-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-header-label-line-height-md-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-header-label-line-height-sm-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-header-label-line-height-xs-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-header-label-line-height-xxs-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-header-label-text-transform-inner);
}
.perxis-auto-1_18_1-dealer-info-header .perxis-auto-1_18_1-dealer-info-header__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-header .perxis-auto-1_18_1-dealer-info-header__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 24px;
}

.perxis-auto-1_18_1-dealer-info-title {
  /* Typography */
  --perxis-auto-dealer-info-title-name-font-family-inner: var(
    --perxis-auto-dealer-info-title-name-font-family,
    var(--perxis-auto-root-typography-h3-font-family-inner)
  );
  --perxis-auto-dealer-info-title-name-font-size-inner: var(
    --perxis-auto-dealer-info-title-name-font-size,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-title-name-font-weight-inner: var(
    --perxis-auto-dealer-info-title-name-font-weight,
    var(--perxis-auto-root-typography-h3-font-weight-inner)
  );
  --perxis-auto-dealer-info-title-name-letter-spacing-inner: var(
    --perxis-auto-dealer-info-title-name-letter-spacing,
    var(--perxis-auto-root-typography-h3-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-title-name-line-height-inner: var(--perxis-auto-dealer-info-title-name-line-height, 1);
  --perxis-auto-dealer-info-title-name-text-transform-inner: var(
    --perxis-auto-dealer-info-title-name-text-transform,
    var(--perxis-auto-root-typography-h3-text-transform-inner)
  );
  --perxis-auto-dealer-info-title-name-color-inner: var(
    --perxis-auto-dealer-info-title-name-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-dealer-info-title-location-font-family-inner: var(
    --perxis-auto-dealer-info-title-location-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-dealer-info-title-location-font-size-inner: var(
    --perxis-auto-dealer-info-title-location-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-title-location-font-weight-inner: var(
    --perxis-auto-dealer-info-title-location-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-dealer-info-title-location-letter-spacing-inner: var(
    --perxis-auto-dealer-info-title-location-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-title-location-line-height-inner: var(
    --perxis-auto-dealer-info-title-location-line-height,
    1.2
  );
  --perxis-auto-dealer-info-title-location-text-transform-inner: var(
    --perxis-auto-dealer-info-title-location-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-dealer-info-title-location-color-inner: var(
    --perxis-auto-dealer-info-title-location-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-dealer-info-title-address-font-family-inner: var(
    --perxis-auto-dealer-info-title-address-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-dealer-info-title-address-font-size-inner: var(
    --perxis-auto-dealer-info-title-address-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-title-address-font-weight-inner: var(
    --perxis-auto-dealer-info-title-address-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-dealer-info-title-address-letter-spacing-inner: var(
    --perxis-auto-dealer-info-title-address-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-title-address-line-height-inner: var(
    --perxis-auto-dealer-info-title-address-line-height,
    var(--perxis-auto-root-typography-main-line-height-inner)
  );
  --perxis-auto-dealer-info-title-address-text-transform-inner: var(
    --perxis-auto-dealer-info-title-address-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-dealer-info-title-address-color-inner: var(
    --perxis-auto-dealer-info-title-address-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  /* End Typography */
  /* End Typography */
}
.perxis-auto-1_18_1-dealer-info-title__name {
  --perxis-auto-typography-h3-font-family: var(--perxis-auto-dealer-info-title-name-font-family-inner);
  --perxis-auto-typography-h3-font-weight: var(--perxis-auto-dealer-info-title-name-font-weight-inner);
  --perxis-auto-typography-h3-letter-spacing: var(--perxis-auto-dealer-info-title-name-letter-spacing-inner);
  --perxis-auto-typography-h3-text-transform: var(--perxis-auto-dealer-info-title-name-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-title-name-color-inner);
  --perxis-auto-typography-h3-font-size-xxs: var(--perxis-auto-dealer-info-title-name-font-size-inner);
  --perxis-auto-typography-h3-font-size-xs: var(--perxis-auto-dealer-info-title-name-font-size-inner);
  --perxis-auto-typography-h3-font-size-sm: var(--perxis-auto-dealer-info-title-name-font-size-inner);
  --perxis-auto-typography-h3-font-size-md: var(--perxis-auto-dealer-info-title-name-font-size-inner);
  --perxis-auto-typography-h3-font-size-lg: var(--perxis-auto-dealer-info-title-name-font-size-inner);
  --perxis-auto-typography-h3-font-size-xl: var(--perxis-auto-dealer-info-title-name-font-size-inner);
  --perxis-auto-typography-h3-font-size-xxl: var(--perxis-auto-dealer-info-title-name-font-size-inner);
  --perxis-auto-typography-h3-line-height-xxs: var(--perxis-auto-dealer-info-title-name-line-height-inner);
  --perxis-auto-typography-h3-line-height-xs: var(--perxis-auto-dealer-info-title-name-line-height-inner);
  --perxis-auto-typography-h3-line-height-sm: var(--perxis-auto-dealer-info-title-name-line-height-inner);
  --perxis-auto-typography-h3-line-height-md: var(--perxis-auto-dealer-info-title-name-line-height-inner);
  --perxis-auto-typography-h3-line-height-lg: var(--perxis-auto-dealer-info-title-name-line-height-inner);
  --perxis-auto-typography-h3-line-height-xl: var(--perxis-auto-dealer-info-title-name-line-height-inner);
  --perxis-auto-typography-h3-line-height-xxl: var(--perxis-auto-dealer-info-title-name-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-title__location {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-dealer-info-title-location-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-dealer-info-title-location-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-dealer-info-title-location-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-dealer-info-title-location-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-dealer-info-title-location-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-dealer-info-title-location-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-dealer-info-title-location-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-dealer-info-title-location-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-dealer-info-title-location-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-dealer-info-title-location-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-dealer-info-title-location-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-dealer-info-title-location-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-dealer-info-title-location-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-dealer-info-title-location-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-dealer-info-title-location-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-dealer-info-title-location-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-dealer-info-title-location-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-dealer-info-title-location-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-dealer-info-title-location-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-title__address {
  --perxis-auto-typography-main-font-family: var(--perxis-auto-dealer-info-title-address-font-family-inner);
  --perxis-auto-typography-main-font-weight: var(--perxis-auto-dealer-info-title-address-font-weight-inner);
  --perxis-auto-typography-main-letter-spacing: var(--perxis-auto-dealer-info-title-address-letter-spacing-inner);
  --perxis-auto-typography-main-text-transform: var(--perxis-auto-dealer-info-title-address-text-transform-inner);
  --perxis-auto-typography-color-dark: var(--perxis-auto-dealer-info-title-address-color-inner);
  --perxis-auto-typography-main-font-size-xxs: var(--perxis-auto-dealer-info-title-address-font-size-inner);
  --perxis-auto-typography-main-font-size-xs: var(--perxis-auto-dealer-info-title-address-font-size-inner);
  --perxis-auto-typography-main-font-size-sm: var(--perxis-auto-dealer-info-title-address-font-size-inner);
  --perxis-auto-typography-main-font-size-md: var(--perxis-auto-dealer-info-title-address-font-size-inner);
  --perxis-auto-typography-main-font-size-lg: var(--perxis-auto-dealer-info-title-address-font-size-inner);
  --perxis-auto-typography-main-font-size-xl: var(--perxis-auto-dealer-info-title-address-font-size-inner);
  --perxis-auto-typography-main-font-size-xxl: var(--perxis-auto-dealer-info-title-address-font-size-inner);
  --perxis-auto-typography-main-line-height-xxs: var(--perxis-auto-dealer-info-title-address-line-height-inner);
  --perxis-auto-typography-main-line-height-xs: var(--perxis-auto-dealer-info-title-address-line-height-inner);
  --perxis-auto-typography-main-line-height-sm: var(--perxis-auto-dealer-info-title-address-line-height-inner);
  --perxis-auto-typography-main-line-height-md: var(--perxis-auto-dealer-info-title-address-line-height-inner);
  --perxis-auto-typography-main-line-height-lg: var(--perxis-auto-dealer-info-title-address-line-height-inner);
  --perxis-auto-typography-main-line-height-xl: var(--perxis-auto-dealer-info-title-address-line-height-inner);
  --perxis-auto-typography-main-line-height-xxl: var(--perxis-auto-dealer-info-title-address-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-title__brand-image {
  max-height: 40px;
  width: auto;
}
.perxis-auto-1_18_1-dealer-info-title__tag {
  margin-inline-end: 8px;
  margin-bottom: 8px;
}
.perxis-auto-1_18_1-dealer-info-title__tag-list {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: -8px;
  overflow: hidden;
}
.perxis-auto-1_18_1-dealer-info-title .perxis-auto-1_18_1-dealer-info-title__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph,
.perxis-auto-1_18_1-dealer-info-title .perxis-auto-1_18_1-dealer-info-title__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-title .perxis-auto-1_18_1-dealer-info-title__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 20px;
}
.perxis-auto-1_18_1-dealer-info-title .perxis-auto-1_18_1-dealer-info-title__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  height: 28px;
}

.perxis-auto-1_18_1-dealer-info-contacts {
  display: inline-flex;
  flex-direction: column;
  /* Typography */
  --perxis-auto-dealer-info-contacts-label-font-family-inner: var(
    --perxis-auto-dealer-info-contacts-label-font-family,
    var(--perxis-auto-dealer-info-phones-label-font-family, var(--perxis-auto-root-typography-small-font-family-inner))
  );
  --perxis-auto-dealer-info-contacts-label-font-size-inner: var(
    --perxis-auto-dealer-info-contacts-label-font-size,
    var(--perxis-auto-dealer-info-phones-label-font-size, 14px)
  );
  --perxis-auto-dealer-info-contacts-label-font-weight-inner: var(
    --perxis-auto-dealer-info-contacts-label-font-weight,
    var(--perxis-auto-dealer-info-phones-label-font-weight, var(--perxis-auto-root-typography-small-font-weight-inner))
  );
  --perxis-auto-dealer-info-contacts-label-letter-spacing-inner: var(
    --perxis-auto-dealer-info-contacts-label-letter-spacing,
    var(
      --perxis-auto-dealer-info-phones-label-letter-spacing,
      var(--perxis-auto-root-typography-small-letter-spacing-inner)
    )
  );
  --perxis-auto-dealer-info-contacts-label-line-height-inner: var(
    --perxis-auto-dealer-info-contacts-label-line-height,
    var(--perxis-auto-dealer-info-phones-label-line-height, 1)
  );
  --perxis-auto-dealer-info-contacts-label-text-transform-inner: var(
    --perxis-auto-dealer-info-contacts-label-text-transform,
    var(
      --perxis-auto-dealer-info-phones-label-text-transform,
      var(--perxis-auto-root-typography-small-text-transform-inner)
    )
  );
  --perxis-auto-dealer-info-contacts-label-color-inner: var(
    --perxis-auto-dealer-info-contacts-label-color,
    var(--perxis-auto-dealer-info-phones-label-color, var(--perxis-auto-root-typography-color-dark-light-inner))
  );
  --perxis-auto-dealer-info-contacts-value-font-family-inner: var(
    --perxis-auto-dealer-info-contacts-value-font-family,
    var(--perxis-auto-dealer-info-phones-value-font-family, var(--perxis-auto-root-typography-small-font-family-inner))
  );
  --perxis-auto-dealer-info-contacts-value-font-size-inner: var(
    --perxis-auto-dealer-info-contacts-value-font-size,
    var(--perxis-auto-dealer-info-phones-value-font-size, var(--perxis-auto-root-typography-small-font-size-xxl-inner))
  );
  --perxis-auto-dealer-info-contacts-value-font-weight-inner: var(
    --perxis-auto-dealer-info-contacts-value-font-weight,
    var(--perxis-auto-dealer-info-phones-value-font-weight, 700)
  );
  --perxis-auto-dealer-info-contacts-value-letter-spacing-inner: var(
    --perxis-auto-dealer-info-contacts-value-letter-spacing,
    var(
      --perxis-auto-dealer-info-phones-value-letter-spacing,
      var(--perxis-auto-root-typography-small-letter-spacing-inner)
    )
  );
  --perxis-auto-dealer-info-contacts-value-line-height-inner: var(
    --perxis-auto-dealer-info-contacts-value-line-height,
    var(--perxis-auto-dealer-info-phones-value-line-height, 1.5)
  );
  --perxis-auto-dealer-info-contacts-value-text-transform-inner: var(
    --perxis-auto-dealer-info-contacts-value-text-transform,
    var(
      --perxis-auto-dealer-info-phones-value-text-transform,
      var(--perxis-auto-root-typography-small-text-transform-inner)
    )
  );
  --perxis-auto-dealer-info-contacts-value-color-inner: var(
    --perxis-auto-dealer-info-contacts-value-color,
    var(--perxis-auto-dealer-info-phones-value-color, var(--perxis-auto-root-typography-color-darkest-inner))
  );
  /* End Typography */
}
.perxis-auto-1_18_1-dealer-info-contacts__label {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-contacts-label-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-contacts-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-contacts-label-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-contacts-label-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-dealer-info-contacts-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-contacts-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-contacts-label-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-contacts-label-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-contacts-label-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-contacts-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-contacts-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-contacts-label-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-contacts-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-contacts-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-contacts-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-contacts-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-contacts-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-contacts-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-contacts-label-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-contacts__value {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-contacts-value-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-contacts-value-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-contacts-value-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-contacts-value-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-contacts-value-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-contacts-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-contacts-value-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-contacts-value-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-contacts-value-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-contacts-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-contacts-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-contacts-value-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-contacts-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-contacts-value-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-contacts-value-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-contacts-value-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-contacts-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-contacts-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-contacts-value-line-height-inner);
  --perxis-auto-typography-link-color: var(--perxis-auto-dealer-info-contacts-value-color-inner);
  --perxis-auto-typography-link-decoration: none;
  --perxis-auto-typography-link-hover-decoration: none;
}
.perxis-auto-1_18_1-dealer-info-contacts__container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 30px;
  margin-top: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_18_1-dealer-info-contacts__container--row {
  flex-direction: column;
}
.perxis-auto-1_18_1-dealer-info-contacts__container--column {
  flex-direction: row;
}
.perxis-auto-1_18_1-dealer-info-contacts .perxis-auto-1_18_1-dealer-info-contacts__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph,
.perxis-auto-1_18_1-dealer-info-contacts .perxis-auto-1_18_1-dealer-info-contacts__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-contacts .perxis-auto-1_18_1-dealer-info-contacts__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 18px;
}

.perxis-auto-1_18_1-dealer-info-schedule {
  /* Typography */
  --perxis-auto-dealer-info-schedule-label-font-family-inner: var(
    --perxis-auto-dealer-info-schedule-label-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-schedule-label-font-size-inner: var(
    --perxis-auto-dealer-info-schedule-label-font-size,
    14px
  );
  --perxis-auto-dealer-info-schedule-label-font-weight-inner: var(
    --perxis-auto-dealer-info-schedule-label-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-schedule-label-letter-spacing-inner: var(
    --perxis-auto-dealer-info-schedule-label-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-schedule-label-line-height-inner: var(
    --perxis-auto-dealer-info-schedule-label-line-height,
    1
  );
  --perxis-auto-dealer-info-schedule-label-text-transform-inner: var(
    --perxis-auto-dealer-info-schedule-label-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-schedule-label-color-inner: var(
    --perxis-auto-dealer-info-schedule-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-dealer-info-schedule-phone-font-family-inner: var(
    --perxis-auto-dealer-info-schedule-phone-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-schedule-phone-font-size-inner: var(
    --perxis-auto-dealer-info-schedule-phone-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-schedule-phone-font-weight-inner: var(
    --perxis-auto-dealer-info-schedule-phone-font-weight,
    700
  );
  --perxis-auto-dealer-info-schedule-phone-letter-spacing-inner: var(
    --perxis-auto-dealer-info-schedule-phone-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-schedule-phone-line-height-inner: var(
    --perxis-auto-dealer-info-schedule-phone-line-height,
    1.5
  );
  --perxis-auto-dealer-info-schedule-phone-text-transform-inner: var(
    --perxis-auto-dealer-info-schedule-phone-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-schedule-phone-color-inner: var(
    --perxis-auto-dealer-info-schedule-phone-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-dealer-info-schedule-email-font-family-inner: var(
    --perxis-auto-dealer-info-schedule-email-font-family,
    var(
      --perxis-auto-dealer-info-schedule-phone-font-family,
      var(--perxis-auto-root-typography-small-font-family-inner)
    )
  );
  --perxis-auto-dealer-info-schedule-email-font-size-inner: var(
    --perxis-auto-dealer-info-schedule-email-font-size,
    var(
      --perxis-auto-dealer-info-schedule-phone-font-size,
      var(--perxis-auto-root-typography-small-font-size-xxl-inner)
    )
  );
  --perxis-auto-dealer-info-schedule-email-font-weight-inner: var(
    --perxis-auto-dealer-info-schedule-email-font-weight,
    var(--perxis-auto-dealer-info-schedule-phone-font-weight, 700)
  );
  --perxis-auto-dealer-info-schedule-email-letter-spacing-inner: var(
    --perxis-auto-dealer-info-schedule-email-letter-spacing,
    var(
      --perxis-auto-dealer-info-schedule-phone-letter-spacing,
      var(--perxis-auto-root-typography-small-letter-spacing-inner)
    )
  );
  --perxis-auto-dealer-info-schedule-email-line-height-inner: var(
    --perxis-auto-dealer-info-schedule-email-line-height,
    var(--perxis-auto-dealer-info-schedule-phone-line-height, 1.5)
  );
  --perxis-auto-dealer-info-schedule-email-text-transform-inner: var(
    --perxis-auto-dealer-info-schedule-email-text-transform,
    var(
      --perxis-auto-dealer-info-schedule-phone-text-transform,
      var(--perxis-auto-root-typography-small-text-transform-inner)
    )
  );
  --perxis-auto-dealer-info-schedule-email-color-inner: var(
    --perxis-auto-dealer-info-schedule-email-color,
    var(--perxis-auto-dealer-info-schedule-phone-color, var(--perxis-auto-root-typography-color-darkest-inner))
  );
  --perxis-auto-dealer-info-schedule-timetable-font-family-inner: var(
    --perxis-auto-dealer-info-schedule-timetable-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-schedule-timetable-font-size-inner: var(
    --perxis-auto-dealer-info-schedule-timetable-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-schedule-timetable-font-weight-inner: var(
    --perxis-auto-dealer-info-schedule-timetable-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-schedule-timetable-letter-spacing-inner: var(
    --perxis-auto-dealer-info-schedule-timetable-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-schedule-timetable-line-height-inner: var(
    --perxis-auto-dealer-info-schedule-timetable-line-height,
    1.5
  );
  --perxis-auto-dealer-info-schedule-timetable-text-transform-inner: var(
    --perxis-auto-dealer-info-schedule-timetable-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-schedule-timetable-color-inner: var(
    --perxis-auto-dealer-info-schedule-timetable-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  /* End Typography */
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.perxis-auto-1_18_1-dealer-info-schedule tr {
  vertical-align: top;
}
.perxis-auto-1_18_1-dealer-info-schedule td,
.perxis-auto-1_18_1-dealer-info-schedule th {
  text-align: start;
  border: 0 solid transparent;
  background-clip: padding-box;
  width: 100%;
}
.perxis-auto-1_18_1-dealer-info-schedule.perxis-auto-1_18_1-dealer-info-schedule--multi td,
.perxis-auto-1_18_1-dealer-info-schedule.perxis-auto-1_18_1-dealer-info-schedule--multi th {
  width: 50%;
}
.perxis-auto-1_18_1-dealer-info-schedule.perxis-auto-1_18_1-dealer-info-schedule--rtl tr > td + td,
.perxis-auto-1_18_1-dealer-info-schedule.perxis-auto-1_18_1-dealer-info-schedule--rtl tr > th + th {
  border-left-width: 0;
  border-right-width: 9px;
}
.perxis-auto-1_18_1-dealer-info-schedule tr > td + td,
.perxis-auto-1_18_1-dealer-info-schedule tr > th + th {
  border-left-width: 9px;
}
.perxis-auto-1_18_1-dealer-info-schedule tr + tr > td {
  border-top-width: calc(var(--perxis-auto-gap-vertical-purple-inner) / 2);
}
.perxis-auto-1_18_1-dealer-info-schedule tr + tr > th {
  border-top-width: var(--perxis-auto-gap-vertical-green-inner);
}
.perxis-auto-1_18_1-dealer-info-schedule__label {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-schedule-label-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-schedule-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-schedule-label-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-schedule-label-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-dealer-info-schedule-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-schedule-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-schedule-label-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-schedule-label-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-schedule-label-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-schedule-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-schedule-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-schedule-label-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-schedule-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-schedule-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-schedule-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-schedule-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-schedule-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-schedule-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-schedule-label-line-height-inner);
  flex: 1;
}
.perxis-auto-1_18_1-dealer-info-schedule__phone {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-schedule-phone-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-schedule-phone-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-schedule-phone-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-schedule-phone-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-schedule-phone-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-schedule-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-schedule-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-schedule-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-schedule-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-schedule-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-schedule-phone-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-schedule-phone-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-schedule-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-schedule-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-schedule-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-schedule-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-schedule-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-schedule-phone-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-schedule-phone-line-height-inner);
  --perxis-auto-typography-link-color: var(--perxis-auto-dealer-info-schedule-phone-color-inner);
  --perxis-auto-typography-link-decoration: none;
  --perxis-auto-typography-link-hover-decoration: none;
}
.perxis-auto-1_18_1-dealer-info-schedule__email {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-schedule-email-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-schedule-email-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-schedule-email-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-schedule-email-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-schedule-email-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-schedule-email-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-schedule-email-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-schedule-email-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-schedule-email-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-schedule-email-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-schedule-email-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-schedule-email-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-schedule-email-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-schedule-email-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-schedule-email-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-schedule-email-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-schedule-email-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-schedule-email-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-schedule-email-line-height-inner);
  --perxis-auto-typography-link-color: var(--perxis-auto-dealer-info-schedule-email-color-inner);
  --perxis-auto-typography-link-decoration: none;
  --perxis-auto-typography-link-hover-decoration: none;
}
.perxis-auto-1_18_1-dealer-info-schedule__timetable {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-schedule-timetable-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-schedule-timetable-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(
    --perxis-auto-dealer-info-schedule-timetable-letter-spacing-inner
  );
  --perxis-auto-typography-small-text-transform: var(
    --perxis-auto-dealer-info-schedule-timetable-text-transform-inner
  );
  --perxis-auto-typography-color-dark: var(--perxis-auto-dealer-info-schedule-timetable-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-schedule-timetable-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-schedule-timetable-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-schedule-timetable-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-schedule-timetable-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-schedule-timetable-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-schedule-timetable-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-schedule-timetable-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-schedule-timetable-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-schedule-timetable-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-schedule-timetable-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-schedule-timetable-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-schedule-timetable-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-schedule-timetable-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-schedule-timetable-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-schedule__container {
  display: inline-flex;
  flex-direction: column;
  gap: 4px 18px;
}
.perxis-auto-1_18_1-dealer-info-schedule .perxis-auto-1_18_1-dealer-info-schedule__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph,
.perxis-auto-1_18_1-dealer-info-schedule .perxis-auto-1_18_1-dealer-info-schedule__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-schedule .perxis-auto-1_18_1-dealer-info-schedule__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 18px;
}

.perxis-auto-1_18_1-dealer-info-site {
  /* Typography */
  --perxis-auto-dealer-info-site-label-font-family-inner: var(
    --perxis-auto-dealer-info-site-label-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-site-label-font-size-inner: var(--perxis-auto-dealer-info-site-label-font-size, 14px);
  --perxis-auto-dealer-info-site-label-font-weight-inner: var(
    --perxis-auto-dealer-info-site-label-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-site-label-letter-spacing-inner: var(
    --perxis-auto-dealer-info-site-label-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-site-label-line-height-inner: var(--perxis-auto-dealer-info-site-label-line-height, 1);
  --perxis-auto-dealer-info-site-label-text-transform-inner: var(
    --perxis-auto-dealer-info-site-label-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-site-label-color-inner: var(
    --perxis-auto-dealer-info-site-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-dealer-info-site-value-font-family-inner: var(
    --perxis-auto-dealer-info-site-value-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-site-value-font-size-inner: var(--perxis-auto-dealer-info-site-value-font-size, 14px);
  --perxis-auto-dealer-info-site-value-font-weight-inner: var(--perxis-auto-dealer-info-site-value-font-weight, 700);
  --perxis-auto-dealer-info-site-value-letter-spacing-inner: var(
    --perxis-auto-dealer-info-site-value-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-site-value-line-height-inner: var(--perxis-auto-dealer-info-site-value-line-height, 1.5);
  --perxis-auto-dealer-info-site-value-text-transform-inner: var(
    --perxis-auto-dealer-info-site-value-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-site-value-color-inner: var(
    --perxis-auto-dealer-info-site-value-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-dealer-info-site-icon-size-inner: var(--perxis-auto-dealer-info-site-icon-size, 18px);
  /* End Typography */
}
.perxis-auto-1_18_1-dealer-info-site__label {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-site-label-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-site-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-site-label-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-site-label-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-dealer-info-site-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-site-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-site-label-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-site-label-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-site-label-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-site-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-site-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-site-label-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-site-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-site-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-site-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-site-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-site-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-site-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-site-label-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-site__value {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-site-value-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-site-value-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-site-value-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-site-value-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-site-value-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-button-font-family: var(--perxis-auto-dealer-info-site-value-font-family-inner);
  --perxis-auto-button-font-weight: var(--perxis-auto-dealer-info-site-value-font-weight-inner);
  --perxis-auto-button-font-size: var(--perxis-auto-dealer-info-site-value-font-size-inner);
  --perxis-auto-button-letter-spacing: var(--perxis-auto-dealer-info-site-value-letter-spacing-inner);
  --perxis-auto-button-line-height: var(--perxis-auto-dealer-info-site-value-line-height-inner);
  --perxis-auto-button-text-transform: var(--perxis-auto-dealer-info-site-value-text-transform-inner);
  --perxis-auto-button-link-color: var(--perxis-auto-dealer-info-site-value-color-inner);
}
.perxis-auto-1_18_1-dealer-info-site__container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px 30px;
  margin-top: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_18_1-dealer-info-site__value {
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-site-value-font-weight-inner);
}
.perxis-auto-1_18_1-dealer-info-site__icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-dealer-info-site-icon-size-inner);
}
.perxis-auto-1_18_1-dealer-info-site .perxis-auto-1_18_1-dealer-info-site__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph,
.perxis-auto-1_18_1-dealer-info-site .perxis-auto-1_18_1-dealer-info-site__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-site .perxis-auto-1_18_1-dealer-info-site__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 18px;
}

.perxis-auto-1_18_1-dealer-info-services {
  /* Typography */
  --perxis-auto-dealer-info-services-label-font-family-inner: var(
    --perxis-auto-dealer-info-services-label-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-services-label-font-size-inner: var(
    --perxis-auto-dealer-info-services-label-font-size,
    14px
  );
  --perxis-auto-dealer-info-services-label-font-weight-inner: var(
    --perxis-auto-dealer-info-services-label-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-services-label-letter-spacing-inner: var(
    --perxis-auto-dealer-info-services-label-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-services-label-line-height-inner: var(
    --perxis-auto-dealer-info-services-label-line-height,
    1
  );
  --perxis-auto-dealer-info-services-label-text-transform-inner: var(
    --perxis-auto-dealer-info-services-label-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-services-label-color-inner: var(
    --perxis-auto-dealer-info-services-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-dealer-info-services-value-font-family-inner: var(
    --perxis-auto-dealer-info-services-value-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-services-value-font-size-inner: var(
    --perxis-auto-dealer-info-services-value-font-size,
    14px
  );
  --perxis-auto-dealer-info-services-value-font-weight-inner: var(
    --perxis-auto-dealer-info-services-value-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-services-value-letter-spacing-inner: var(
    --perxis-auto-dealer-info-services-value-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-services-value-line-height-inner: var(
    --perxis-auto-dealer-info-services-value-line-height,
    1.5
  );
  --perxis-auto-dealer-info-services-value-text-transform-inner: var(
    --perxis-auto-dealer-info-services-value-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-services-value-color-inner: var(
    --perxis-auto-dealer-info-services-value-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  --perxis-auto-dealer-info-services-icon-size-inner: var(--perxis-auto-dealer-info-services-icon-size, 21px);
  /* End Typography */
  /* Colors */
  --perxis-auto-dealer-info-services-icon-color-inner: var(
    --perxis-auto-dealer-info-services-icon-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  /* End Colors */
}
.perxis-auto-1_18_1-dealer-info-services__label {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-services-label-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-services-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-services-label-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-services-label-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-dealer-info-services-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-services-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-services-label-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-services-label-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-services-label-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-services-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-services-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-services-label-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-services-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-services-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-services-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-services-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-services-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-services-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-services-label-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-services__value {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-services-value-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-services-value-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-services-value-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-services-value-text-transform-inner);
  --perxis-auto-typography-color-dark: var(--perxis-auto-dealer-info-services-value-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-services-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-services-value-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-services-value-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-services-value-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-services-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-services-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-services-value-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-services-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-services-value-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-services-value-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-services-value-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-services-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-services-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-services-value-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-services__container {
  display: grid;
  gap: var(--perxis-auto-gap-vertical-blue-inner) 18px;
  margin-top: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_18_1-dealer-info-services__container--column {
  grid-template-columns: repeat(2, 1fr);
}
.perxis-auto-1_18_1-dealer-info-services__container--row {
  grid-template-columns: repeat(1, 1fr);
}
.perxis-auto-1_18_1-dealer-info-services__service {
  display: flex;
  align-items: center;
  background-repeat: no-repeat;
  background-position: left center;
}
.perxis-auto-1_18_1-dealer-info-services__service-icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-dealer-info-services-icon-size-inner);
  color: var(--perxis-auto-dealer-info-services-icon-color-inner);
  margin-inline-end: 8px;
  line-height: 1;
}
.perxis-auto-1_18_1-dealer-info-services__service-icon-empty {
  width: var(--perxis-auto-dealer-info-services-icon-size-inner);
}
.perxis-auto-1_18_1-dealer-info-services .perxis-auto-1_18_1-dealer-info-services__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph,
.perxis-auto-1_18_1-dealer-info-services .perxis-auto-1_18_1-dealer-info-services__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-services .perxis-auto-1_18_1-dealer-info-services__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 18px;
}

.perxis-auto-1_18_1-dealer-info-rating {
  /* Typography */
  --perxis-auto-dealer-info-rating-label-font-family-inner: var(
    --perxis-auto-dealer-info-rating-label-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-rating-label-font-size-inner: var(--perxis-auto-dealer-info-rating-label-font-size, 14px);
  --perxis-auto-dealer-info-rating-label-font-weight-inner: var(
    --perxis-auto-dealer-info-rating-label-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-rating-label-letter-spacing-inner: var(
    --perxis-auto-dealer-info-rating-label-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-rating-label-line-height-inner: var(--perxis-auto-dealer-info-rating-label-line-height, 1);
  --perxis-auto-dealer-info-rating-label-text-transform-inner: var(
    --perxis-auto-dealer-info-rating-label-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-rating-label-color-inner: var(
    --perxis-auto-dealer-info-rating-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-dealer-info-rating-value-font-family-inner: var(
    --perxis-auto-dealer-info-rating-value-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-rating-value-font-size-inner: var(
    --perxis-auto-dealer-info-rating-value-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-rating-value-font-weight-inner: var(
    --perxis-auto-dealer-info-rating-value-font-weight,
    700
  );
  --perxis-auto-dealer-info-rating-value-letter-spacing-inner: var(
    --perxis-auto-dealer-info-rating-value-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-rating-value-line-height-inner: var(
    --perxis-auto-dealer-info-rating-value-line-height,
    1.5
  );
  --perxis-auto-dealer-info-rating-value-text-transform-inner: var(
    --perxis-auto-dealer-info-rating-value-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-rating-value-color-inner: var(
    --perxis-auto-dealer-info-rating-value-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-dealer-info-rating-name-font-family-inner: var(
    --perxis-auto-dealer-info-rating-name-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-rating-name-font-size-inner: var(
    --perxis-auto-dealer-info-rating-name-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-rating-name-font-weight-inner: var(--perxis-auto-dealer-info-rating-name-font-weight, 400);
  --perxis-auto-dealer-info-rating-name-letter-spacing-inner: var(
    --perxis-auto-dealer-info-rating-name-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-rating-name-line-height-inner: var(--perxis-auto-dealer-info-rating-name-line-height, 1.5);
  --perxis-auto-dealer-info-rating-name-text-transform-inner: var(
    --perxis-auto-dealer-info-rating-name-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-rating-name-color-inner: var(
    --perxis-auto-dealer-info-rating-name-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-dealer-info-rating-counter-font-family-inner: var(
    --perxis-auto-dealer-info-rating-counter-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-rating-counter-font-size-inner: var(
    --perxis-auto-dealer-info-rating-counter-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-rating-counter-font-weight-inner: var(
    --perxis-auto-dealer-info-rating-counter-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-rating-counter-letter-spacing-inner: var(
    --perxis-auto-dealer-info-rating-counter-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-rating-counter-line-height-inner: var(
    --perxis-auto-dealer-info-rating-counter-line-height,
    var(--perxis-auto-root-typography-small-line-height-inner)
  );
  --perxis-auto-dealer-info-rating-counter-text-transform-inner: var(
    --perxis-auto-dealer-info-rating-counter-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-rating-counter-color-inner: var(
    --perxis-auto-dealer-info-rating-counter-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-dealer-info-rating-icon-size-inner: var(--perxis-auto-dealer-info-rating-icon-size, 18px);
  /* End Typography */
  /* Colors */
  --perxis-auto-dealer-info-rating-icon-color-inner: var(
    --perxis-auto-dealer-info-rating-icon-color,
    var(--perxis-auto-root-fourth-color-inner)
  );
  /* End Colors */
}
.perxis-auto-1_18_1-dealer-info-rating__label {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-rating-label-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-rating-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-rating-label-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-rating-label-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-dealer-info-rating-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-rating-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-rating-label-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-rating-label-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-rating-label-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-rating-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-rating-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-rating-label-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-rating-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-rating-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-rating-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-rating-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-rating-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-rating-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-rating-label-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-rating__value {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-rating-value-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-rating-value-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-rating-value-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-rating-value-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-rating-value-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-rating-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-rating-value-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-rating-value-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-rating-value-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-rating-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-rating-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-rating-value-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-rating-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-rating-value-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-rating-value-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-rating-value-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-rating-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-rating-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-rating-value-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-rating__name {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-rating-name-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-rating-name-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-rating-name-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-rating-name-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-rating-name-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-rating-name-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-rating-name-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-rating-name-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-rating-name-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-rating-name-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-rating-name-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-rating-name-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-rating-name-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-rating-name-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-rating-name-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-rating-name-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-rating-name-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-rating-name-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-rating-name-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-rating__counter {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-rating-counter-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-rating-counter-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-rating-counter-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-rating-counter-text-transform-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-dealer-info-rating-counter-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-rating-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-rating-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-rating-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-rating-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-rating-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-rating-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-rating-counter-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-rating-counter-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-rating-counter-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-rating-counter-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-rating-counter-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-rating-counter-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-rating-counter-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-rating-counter-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-rating__icon {
  --perxis-auto-icon-font-size: var(--perxis-auto-dealer-info-rating-icon-size-inner);
  color: var(--perxis-auto-dealer-info-rating-icon-color-inner);
}
.perxis-auto-1_18_1-dealer-info-rating__container {
  display: flex;
  gap: var(--perxis-auto-gap-vertical-purple-inner);
  margin-top: var(--perxis-auto-gap-vertical-purple-inner);
  align-items: center;
}
.perxis-auto-1_18_1-dealer-info-rating .perxis-auto-1_18_1-dealer-info-rating__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph,
.perxis-auto-1_18_1-dealer-info-rating .perxis-auto-1_18_1-dealer-info-rating__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-rating .perxis-auto-1_18_1-dealer-info-rating__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 18px;
}

.perxis-auto-1_18_1-dealer-info-buttons {
  --perxis-auto-dealer-info-buttons-font-size-inner: var(
    --perxis-auto-dealer-info-buttons-font-size,
    var(--perxis-auto-button-font-size)
  );
  --perxis-auto-dealer-info-buttons-font-weight-inner: var(--perxis-auto-dealer-info-buttons-font-weight, 400);
  --perxis-auto-dealer-info-buttons-line-height-inner: var(
    --perxis-auto-dealer-info-buttons-line-height,
    var(--perxis-auto-button-line-height)
  );
  display: flex;
  flex-direction: column;
  gap: var(--perxis-auto-gap-vertical-purple-inner);
}
.perxis-auto-1_18_1-dealer-info-buttons .perxis-auto-1_18_1-dealer-info-buttons__skeleton .ant-5_24_1-skeleton .ant-5_24_1-skeleton-button {
  height: 48px;
}
.perxis-auto-1_18_1-dealer-info-buttons__button {
  --perxis-auto-button-font-size: var(--perxis-auto-dealer-info-buttons-font-size-inner);
  --perxis-auto-button-font-weight: var(--perxis-auto-dealer-info-buttons-font-weight-inner);
  --perxis-auto-button-line-height-inner: var(--perxis-auto-dealer-info-buttons-line-height-inner);
}

.perxis-auto-1_18_1-dealer-info-extra {
  /* Typography */
  --perxis-auto-dealer-info-extra-label-font-family-inner: var(
    --perxis-auto-dealer-info-extra-label-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-extra-label-font-size-inner: var(--perxis-auto-dealer-info-extra-label-font-size, 14px);
  --perxis-auto-dealer-info-extra-label-font-weight-inner: var(
    --perxis-auto-dealer-info-extra-label-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-extra-label-letter-spacing-inner: var(
    --perxis-auto-dealer-info-extra-label-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-extra-label-line-height-inner: var(--perxis-auto-dealer-info-extra-label-line-height, 1);
  --perxis-auto-dealer-info-extra-label-text-transform-inner: var(
    --perxis-auto-dealer-info-extra-label-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-extra-label-color-inner: var(
    --perxis-auto-dealer-info-extra-label-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-dealer-info-extra-value-font-family-inner: var(
    --perxis-auto-dealer-info-extra-value-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-dealer-info-extra-value-font-size-inner: var(
    --perxis-auto-dealer-info-extra-value-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-dealer-info-extra-value-font-weight-inner: var(
    --perxis-auto-dealer-info-extra-value-font-weight,
    var(--perxis-auto-root-typography-small-font-weight-inner)
  );
  --perxis-auto-dealer-info-extra-value-letter-spacing-inner: var(
    --perxis-auto-dealer-info-extra-value-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --perxis-auto-dealer-info-extra-value-line-height-inner: var(--perxis-auto-dealer-info-extra-value-line-height, 1.5);
  --perxis-auto-dealer-info-extra-value-text-transform-inner: var(
    --perxis-auto-dealer-info-extra-value-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --perxis-auto-dealer-info-extra-value-color-inner: var(
    --perxis-auto-dealer-info-extra-value-color,
    var(--perxis-auto-root-typography-color-dark-inner)
  );
  /* End Typography */
}
.perxis-auto-1_18_1-dealer-info-extra__label {
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-extra-label-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-extra-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-extra-label-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-extra-label-text-transform-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-dealer-info-extra-label-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-extra-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-extra-label-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-extra-label-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-extra-label-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-extra-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-extra-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-extra-label-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-extra-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-extra-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-extra-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-extra-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-extra-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-extra-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-extra-label-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-extra__value {
  display: flex;
  flex-direction: column;
  --perxis-auto-typography-small-font-family: var(--perxis-auto-dealer-info-extra-value-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-dealer-info-extra-value-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-dealer-info-extra-value-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--perxis-auto-dealer-info-extra-value-text-transform-inner);
  --perxis-auto-typography-color-dark: var(--perxis-auto-dealer-info-extra-value-color-inner);
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-dealer-info-extra-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-dealer-info-extra-value-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-dealer-info-extra-value-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-dealer-info-extra-value-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-dealer-info-extra-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-dealer-info-extra-value-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-dealer-info-extra-value-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--perxis-auto-dealer-info-extra-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--perxis-auto-dealer-info-extra-value-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--perxis-auto-dealer-info-extra-value-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--perxis-auto-dealer-info-extra-value-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--perxis-auto-dealer-info-extra-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--perxis-auto-dealer-info-extra-value-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--perxis-auto-dealer-info-extra-value-line-height-inner);
}
.perxis-auto-1_18_1-dealer-info-extra .perxis-auto-1_18_1-dealer-info-extra__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph,
.perxis-auto-1_18_1-dealer-info-extra .perxis-auto-1_18_1-dealer-info-extra__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-title {
  margin: 0;
}
.perxis-auto-1_18_1-dealer-info-extra .perxis-auto-1_18_1-dealer-info-extra__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li {
  height: 18px;
}
.perxis-auto-1_18_1-dealer-info-extra .perxis-auto-1_18_1-dealer-info-extra__skeleton .ant-5_24_1-skeleton-content .ant-5_24_1-skeleton-paragraph > li + li {
  margin-top: var(--perxis-auto-gap-vertical-purple-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
